<template>
  <div style="margin-bottom:25px;">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="data" label="序号" align="center" width="230"></el-table-column>
      <el-table-column prop="data2" label="年度" width="300" align="center"></el-table-column>
      <el-table-column prop="data3" label="奖项" width="300" align="center"></el-table-column>
      <el-table-column prop="data4" label="颁奖机构" min-width="300" align="center"></el-table-column>
      <el-table-column prop="" label="基金经理" width="290" align="center">
      <template slot-scope="scope">
            <a style="color:#4372ba;cursor: pointer;">
              {{scope.row.data5}}
            </a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          data: "1",
          data2: "2021",
          data3: "明星基金奖",
          data4: "证券时报",
          data5: "高宏华",
        },
        {
          data: "2",
          data2: "2020",
          data3: "金牛奖",
          data4: "中国证券报",
          data5: "钱均",
        },
        {
          data: "3",
          data2: "2020",
          data3: "明星基金奖",
          data4: "中国证券报",
          data5: "钱均",
        },
        {
          data: "4",
          data2: "2015",
          data3: "明星基金奖",
          data4: "中国证券报",
          data5: "钱均",
        },
      ],
    };
  },
};
</script>

<style scoped>
.el-table /deep/ th {
  background-color: #f8f9fd !important;
  text-align: center;
  height: 56px;
}
.el-table /deep/ td {
  height: 56px;
}
.bg1{
    width: 44px;
	height: 8px;
    background-color: rgba(252,173,42,1);
    margin-left: 3px;
    margin-top: 4px;
}
.bg2{
    background-color: rgba(252,173,42,.12);
}
.border_radius_left{
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
.border_radius_right{
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
.box{
    display: flex;
    justify-content: center;
}
.bg_box{
    display: flex;
}
.text_box{
    margin-left: 6px;
    font-size: 16px;
	line-height: 16px;
	color: #fcad2a;
}
.color_red{
  color: #fd4c4c;
}
.color_green{
  color: #41b357;
  
}
</style>